import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
	import { useComputedStyle } from '@/HostApp/services/SystemLayout/SystemLayoutModule';
	import { serverProps } from '@/Common/Environment/const';

	
	const __default__ = {
		name: 'ComputedGridItem',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		item: {
			type: Object as PropType<LAYOUT.IGridItem>,
			required: true
		}
	},
  setup(__props) {

const props = __props

	

	const computedStyle = computed(() => useComputedStyle(props.item));
	const computedProps = computed(() => props.item.props);
	const computedComponent = computed(() => props.item.component);
	const computedListeners = computed(() => props.item.listeners);
	const shadowRootOptions = computed(() => props.item.useShadowRoot && !serverProps._vueWorkspace);

	const properties = [
		'gridArea',
		'gridRowStart',
		'gridRowEnd',
		'gridRow',
		'gridColumn',
		'gridColumnStart',
		'gridColumnEnd'
	];

	const hasProperty = (arr: Array<string> = []): boolean => {
		return arr.some((item) => properties.includes(item));
	};

	const mixedComputedStyle = computed(() => {
		const { value } = computedStyle.value;

		if (hasProperty(Object.keys(value))) {
			return value;
		} else {
			return {
				...value,
				gridArea: props.item.name
			};
		}
	});

return { __sfc: true,props, computedStyle, computedProps, computedComponent, computedListeners, shadowRootOptions, properties, hasProperty, mixedComputedStyle }
}

})